<template>
  <main class="billing-page">
    <section class="billing-card">
      <header>
        <p>Subscription</p>
        <h1>Annual License</h1>
      </header>
      <div class="billing-summary">
        <span>Status</span>
        <strong>Active</strong>
      </div>
    </section>
  </main>
</template>
<style scoped>
.billing-page {
  display: grid;
  align-content: start;
  min-height: calc(100vh - 24px);
  padding: 12px;
  background: #fff;
  color: #172033;
  font-family: Montserrat, Inter, system-ui, sans-serif;
}

.billing-card {
  max-width: 760px;
  padding: 18px;
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  background: #fff;
}

.billing-card header {
  padding-bottom: 12px;
  border-bottom: 1px solid #e2e8f0;
}

.billing-card p,
.billing-card h1 {
  margin: 0;
}

.billing-card p {
  color: #64748b;
  font-size: 11px;
  font-weight: 900;
  text-transform: uppercase;
}

.billing-card h1 {
  color: #172033;
  font-size: 20px;
  line-height: 1.15;
}

.billing-summary {
  display: grid;
  gap: 4px;
  padding: 12px;
  margin-top: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 7px;
  background: #f8fafc;
}

.billing-summary span {
  color: #64748b;
  font-size: 11px;
  font-weight: 900;
  text-transform: uppercase;
}

.billing-summary strong {
  color: #172033;
  font-size: 14px;
}
</style>
